export const SUPPORT_EMAILS = {
  CUSTOMER_SERVICE: "customerservice@hoteltrader.com",
  OPERATIONS: "ops@hoteltrader.com",
  AP_INVOICE: "apinvoice@hoteltrader.com",
};

export const SUPPORT_PHONES = {
  CUSTOMER_SERVICE: "+1 646 847 9944",
  BILLING: "+1 646 847 9945",
};

export const SUPPORT_HOURS = {
  TWENTY_FOUR_SEVEN: "24/7, 365 days a year",
  OPERATIONS: "Mon-Fri 7am - 8pm EST",
  BILLING: "Mon-Fri 9am - 6pm EST",
};
